import { onApplicationMenu, onTopLevelRoutes } from 'core';
import { Overview } from './overview/Overview';

onTopLevelRoutes(() => ({
  path: '/trash',
  secure: true,
  component: Overview,
}));

onApplicationMenu(() => ({
  group: 'stock',
  label: 'trash',
  icon: 'trash',
  to: '/trash',
}));
